import React, { useEffect } from "react";
import { MessageProps } from "../../../typings/messages";
import Message from "./Message";
import './chat.css';

export interface MessageContainerProps {
   messages: MessageProps[];
   memberCode: number;
   chatMemberImage: string | null;
   chatRecipientNickName: string;
   answerBreakTheIce: (data: any) => void;
   sendBreakTheIce: (data: any) => void;

}

export interface renderRowProps {
   item: MessageProps;
   index: number;

}

const MessageContainer = ({ answerBreakTheIce, sendBreakTheIce, chatMemberImage, messages, memberCode, chatRecipientNickName }: MessageContainerProps) => {

   const imageMessages = messages.filter(item => item.image && typeof item.image === "string").map(item => item.image);
   const imageMessagesProfile = messages.filter(item => item.image && typeof item.image !== "string").map(item => item.image);

   const renderRow = (item: MessageProps, index: number) => {

      if (!item.messageId && item.messageId !== 0) {
         console.warn('bounakirChat: `id` is missing for message', JSON.stringify(item));
      }
      const previousMessage = messages[index + 1] || {};
      const nextMessage = messages[index - 1] || {};

      const messageProps = {
         key: item.messageId,
         currentMessage: item,
         previousMessage,
         nextMessage,
         chatMemberImage,
         answerBreakTheIce,
         sendBreakTheIce,
         position: item.chatMemberCode === memberCode ? 'left' : 'right',
         imageMessages,
         memberCode,
         chatRecipientNickName
      };

      return <Message {...messageProps} />;
   };

   return (
      <>
         {messages.map((message, index): any => {
            return renderRow(message, index);
         })}

      </>
   )

}

export default MessageContainer;